// Analytical Skills organized by subcategories
export const ANALYTICAL_SKILLS_CATEGORIES = [
  {
    name: 'Data Analysis',
    skills: [
      'Statistical Analysis', 'Data Mining', 'Pattern Recognition',
      'Trend Analysis', 'Predictive Analytics', 'Descriptive Analytics',
      'Data Visualization', 'Data Cleaning', 'Data Validation',
      'Quantitative Analysis', 'Qualitative Analysis', 'Regression Analysis',
      'Time Series Analysis', 'Cluster Analysis', 'Factor Analysis'
    ]
  },
  {
    name: 'Research Methods',
    skills: [
      'Research Design', 'Hypothesis Testing', 'Experimental Design',
      'Survey Methods', 'Sampling Techniques', 'Literature Review',
      'Case Study Analysis', 'Research Planning', 'Data Collection',
      'Research Documentation', 'Methodology Development', 'Research Ethics',
      'Research Validation', 'Research Tools', 'Research Reporting'
    ]
  },
  {
    name: 'Problem Solving',
    skills: [
      'Critical Thinking', 'Root Cause Analysis', 'Decision Making',
      'Solution Development', 'Process Analysis', 'Systems Thinking',
      'Analytical Reasoning', 'Problem Definition', 'Option Analysis',
      'Risk Assessment', 'Impact Analysis', 'Solution Testing',
      'Implementation Planning', 'Performance Monitoring', 'Continuous Improvement'
    ]
  },
  {
    name: 'Business Analysis',
    skills: [
      'Requirements Analysis', 'Process Modeling', 'Business Intelligence',
      'Market Analysis', 'Competitive Analysis', 'Financial Analysis',
      'Cost-Benefit Analysis', 'Performance Metrics', 'Stakeholder Analysis',
      'Strategy Development', 'Risk Management', 'Change Management',
      'Process Improvement', 'Documentation', 'Reporting'
    ]
  },
  {
    name: 'Quantitative Methods',
    skills: [
      'Mathematical Analysis', 'Statistical Methods', 'Probability Theory',
      'Numerical Analysis', 'Operations Research', 'Financial Modeling',
      'Economic Analysis', 'Optimization Methods', 'Simulation Modeling',
      'Risk Modeling', 'Forecasting', 'Sampling Methods',
      'Data Modeling', 'Algorithm Development', 'Mathematical Programming'
    ]
  },
  {
    name: 'Data Management',
    skills: [
      'Database Design', 'Data Architecture', 'Data Quality Management',
      'Data Governance', 'Metadata Management', 'Data Integration',
      'Data Security', 'Data Storage', 'Data Retrieval',
      'Version Control', 'Documentation', 'Data Standards',
      'Data Lifecycle', 'Data Tools', 'Best Practices'
    ]
  },
  {
    name: 'Project Analysis',
    skills: [
      'Project Assessment', 'Resource Analysis', 'Timeline Analysis',
      'Cost Analysis', 'Risk Analysis', 'Stakeholder Analysis',
      'Performance Analysis', 'Quality Analysis', 'Impact Assessment',
      'Feasibility Studies', 'Requirements Analysis', 'Project Planning',
      'Progress Monitoring', 'Project Documentation', 'Reporting'
    ]
  },
  {
    name: 'Financial Analysis',
    skills: [
      'Financial Modeling', 'Budget Analysis', 'Cost Analysis',
      'Investment Analysis', 'Risk Assessment', 'Valuation Methods',
      'Performance Metrics', 'Financial Planning', 'Financial Forecasting',
      'Portfolio Analysis', 'Market Analysis', 'Financial Reporting',
      'Trend Analysis', 'Ratio Analysis', 'Scenario Analysis'
    ]
  },
  {
    name: 'Market Analysis',
    skills: [
      'Market Research', 'Competitor Analysis', 'Consumer Behavior',
      'Trend Analysis', 'Market Segmentation', 'Pricing Analysis',
      'Demand Analysis', 'Supply Analysis', 'Channel Analysis',
      'Product Analysis', 'Brand Analysis', 'Market Forecasting',
      'Market Strategy', 'Market Reports', 'Performance Metrics'
    ]
  },
  {
    name: 'Process Analysis',
    skills: [
      'Process Mapping', 'Workflow Analysis', 'Efficiency Analysis',
      'Quality Analysis', 'Performance Analysis', 'Cost Analysis',
      'Time Analysis', 'Resource Analysis', 'Bottleneck Analysis',
      'Process Improvement', 'Process Documentation', 'Process Design',
      'Process Testing', 'Process Implementation', 'Process Monitoring'
    ]
  },
  {
    name: 'Systems Analysis',
    skills: [
      'Systems Thinking', 'Requirements Analysis', 'System Design',
      'Integration Analysis', 'Performance Analysis', 'Security Analysis',
      'Risk Analysis', 'Cost Analysis', 'Impact Analysis',
      'Feasibility Studies', 'System Documentation', 'System Testing',
      'System Implementation', 'System Monitoring', 'System Maintenance'
    ]
  },
  {
    name: 'Quality Analysis',
    skills: [
      'Quality Control', 'Quality Assurance', 'Performance Testing',
      'Process Validation', 'Standards Compliance', 'Quality Metrics',
      'Quality Planning', 'Quality Tools', 'Quality Documentation',
      'Root Cause Analysis', 'Corrective Actions', 'Preventive Actions',
      'Quality Reporting', 'Quality Training', 'Continuous Improvement'
    ]
  },
  {
    name: 'Risk Analysis',
    skills: [
      'Risk Assessment', 'Risk Identification', 'Risk Quantification',
      'Risk Mitigation', 'Risk Monitoring', 'Risk Reporting',
      'Risk Management', 'Risk Documentation', 'Risk Communication',
      'Contingency Planning', 'Impact Analysis', 'Probability Analysis',
      'Risk Tools', 'Risk Standards', 'Best Practices'
    ]
  },
  {
    name: 'Performance Analysis',
    skills: [
      'Performance Metrics', 'KPI Development', 'Benchmark Analysis',
      'Efficiency Analysis', 'Productivity Analysis', 'Cost Analysis',
      'Quality Analysis', 'Time Analysis', 'Resource Analysis',
      'Performance Reporting', 'Performance Improvement', 'Performance Tools',
      'Performance Standards', 'Best Practices', 'Continuous Monitoring'
    ]
  },
  {
    name: 'Decision Analysis',
    skills: [
      'Decision Making', 'Option Analysis', 'Criteria Development',
      'Impact Assessment', 'Risk Assessment', 'Cost-Benefit Analysis',
      'Decision Tools', 'Decision Documentation', 'Decision Communication',
      'Stakeholder Analysis', 'Implementation Planning', 'Performance Monitoring',
      'Decision Review', 'Lessons Learned', 'Best Practices'
    ]
  }
];

// Export flattened list for backward compatibility
export const ANALYTICAL_SKILLS = ANALYTICAL_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
